export const QUOTES_URL = 'https://dividendos-quotes.s3.us-east-1.amazonaws.com/prices.json';

export const FORECAST_URL = 'https://dividendos-forecast.s3.us-east-1.amazonaws.com/projections/medians-current-next.json';
